import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { CatCollectAmountRangeModel } from 'src/app/model/cat-collect-amount-range.model';

@Injectable({
  providedIn: 'root'
})
export class CatCollectAmountRangeService {
  private url:string;

  ////////////////
  constructor(
    private http:HttpClient
  ) {
    this.url=environment.services_url;
  }

  //
  catalog=()=> {
    return this.http.get(`${this.url}/CatCollectAmountRange/Catalog`)
      .pipe(
        map((resp:any)=> resp)
      );
  }
  getAll=()=> {
    return this.http.get(`${this.url}/CatCollectAmountRange/List`)
      .pipe(
        map((resp:any)=> resp)
      );
  }
  getAllActive=()=> {
    return this.http.get(`${this.url}/CatCollectAmountRange/List`)
      .pipe(
        map((resp:any)=> resp.filter(range=> range.activeId))
      );
  }
  save=(range:CatCollectAmountRangeModel)=> {
    return this.http.post(`${this.url}/CatCollectAmountRange/SaveUpdate`, range)
      .pipe(
        map((resp:any)=> resp)
      );
  }
  update=(range:CatCollectAmountRangeModel)=> {
    return this.http.post(`${this.url}/CatCollectAmountRange/SaveUpdate/${range.collectAmountRangeId}`, range)
      .pipe(
        map((resp:any)=> resp)
      );
  }
}